const hexToRgb = (h) => {
  const n = parseInt(h.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

export const strokeSeg = (ctx, tool, color, size, a, b) => {
  ctx.save();
  ctx.lineCap = "round";
  ctx.lineJoin = "round";
  if (tool === "crayon") {
    ctx.fillStyle = color;
    const dist = Math.hypot(b.x - a.x, b.y - a.y);
    const steps = Math.max(1, dist / 2);
    for (let i = 0; i < steps; i++) {
      const t = i / steps;
      const x = a.x + (b.x - a.x) * t, y = a.y + (b.y - a.y) * t;
      for (let k = 0; k < 6; k++) {
        ctx.globalAlpha = 0.25 + Math.random() * 0.35;
        const r = Math.random() * size * 0.5;
        const ang = Math.random() * Math.PI * 2;
        ctx.fillRect(x + Math.cos(ang) * r, y + Math.sin(ang) * r, 2.2, 2.2);
      }
    }
  } else {
    ctx.strokeStyle = tool === "eraser" ? "#FFFFFF" : color;
    ctx.globalAlpha = tool === "marker" ? 0.55 : 1;
    ctx.lineWidth = tool === "brush" ? Math.max(size * 0.5, size * 1.4 - Math.hypot(b.x - a.x, b.y - a.y) * 0.4) : tool === "markerLive" ? size * 1.3 : size;
    ctx.beginPath();
    ctx.moveTo(a.x, a.y);
    ctx.lineTo(b.x, b.y);
    ctx.stroke();
  }
  ctx.restore();
};

export const stamp = (ctx, emoji, size, p) => {
  ctx.save();
  ctx.font = `${size}px "Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(emoji, p.x, p.y);
  ctx.restore();
};

// Fills the region under p on the paint layer; `walls` (optional alpha mask) blocks the fill like line art does.
export const floodFill = (ctx, p, color, walls) => {
  const { width: w, height: h } = ctx.canvas;
  const img = ctx.getImageData(0, 0, w, h);
  const d = img.data;
  const x0 = Math.floor(p.x), y0 = Math.floor(p.y);
  if (x0 < 0 || y0 < 0 || x0 >= w || y0 >= h) return false;
  const isWall = (i) => walls && walls[i * 4 + 3] > 90;
  const start = y0 * w + x0;
  if (isWall(start)) return false;
  const [sr, sg, sb] = [d[start * 4], d[start * 4 + 1], d[start * 4 + 2]];
  const [r, g, b] = hexToRgb(color);
  if (Math.abs(sr - r) + Math.abs(sg - g) + Math.abs(sb - b) < 10) return false;
  const tol = 90;
  const seen = new Uint8Array(w * h);
  const match = (i) => !seen[i] && !isWall(i) && Math.abs(d[i * 4] - sr) + Math.abs(d[i * 4 + 1] - sg) + Math.abs(d[i * 4 + 2] - sb) <= tol;
  const stack = [start];
  const filled = [];
  while (stack.length) {
    const i = stack.pop();
    if (!match(i)) continue;
    let x = i % w;
    const y = (i - x) / w;
    let l = i;
    while (x > 0 && match(l - 1)) { l--; x--; }
    let j = l;
    let up = false, down = false;
    while (j < y * w + w && match(j)) {
      seen[j] = 1;
      filled.push(j);
      if (y > 0) { const m = match(j - w); if (m && !up) stack.push(j - w); up = m; }
      if (y < h - 1) { const m = match(j + w); if (m && !down) stack.push(j + w); down = m; }
      j++;
    }
  }
  for (const i of filled) { d[i * 4] = r; d[i * 4 + 1] = g; d[i * 4 + 2] = b; d[i * 4 + 3] = 255; }
  ctx.putImageData(img, 0, 0);
  return true;
};
